import TransactionSeamlessList from './transaction-seamless.list';

export default {
  list: TransactionSeamlessList,
};
